<template>
  <div class="wrap">
    <div class="mb-5">
      <p class="averta-black label-20">{{title}}</p>
      <p>
        Masukkan informasi {{ titlePusat }}.
      </p>
    </div>
    <div>
      <div class="wrap-form">
        <div v-for="(data, index) in dataPic" :key="index">
          <FormHeadE
            :isDelete="index > 0"
            :dataProps="data"
            :index="index"
            @updateHead="updateHead($event)"
            @deleteHead="deleteHead($event)"
            :typeSection="typeSection"
            :disabledInput="disabledInput"
          />
        </div>
        <AddPicBranchBanner
          v-if="typeSection !== 'edit'"
          @addPic="addPic"
          widthButton="180px"
          :title="`Tambah ${title} lainnya?`"
          :desc="`Kamu dapat menambahkan lebih dari 1 ${title}`"
          :titleButton="`+ ${title}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HEAD_ENGINEERING_SMRC } from '@/helpers/constants'
import { titlePusat } from '@/helpers'

import FormHeadE from './FormHeadE.vue'
import AddPicBranchBanner from '../branch-components/AddPicBranchBanner.vue'

export default {
  name: 'BranchInfo',
  props: {
    currentTab: {
      type: String,
      default: null
    },
    typeSection: {
      type: String,
      default: null
    }
  },
  components: {
    FormHeadE,
    AddPicBranchBanner
  },
  computed: {
    ...mapGetters({
      detailPICBranch: 'client/getDetailPICBranch',
      payloadAddPicBranch: 'client/getPayloadAddPicBranch',
      clearDataPayloadPicBranch: 'client/getClearDataPayloadPicBranch'
    }),
    titlePusat () {
      return titlePusat()
    }
  },
  data () {
    return {
      title: HEAD_ENGINEERING_SMRC,
      dataPic: [
        {
          name: '',
          email: '',
          phone: ''
        }
      ],
      disabledInput: true
    }
  },
  methods: {
    addPic () {
      this.dataPic.push({
        name: '',
        email: '',
        phone: ''
      })
    },
    deleteHead (index) {
      this.dataPic.splice(index, 1)
    },
    updateHead (data) {
      this.dataPic[data.index] = data.data
    },
    selectedPIC (data) {
      if (this.typeSection === 'edit' && data) {
        const { id = '', name = '', email = '', phone = '' } = data
        this.dataPic = [
          {
            id,
            name,
            email,
            phone
          }
        ]
      }
    }
  },
  created () {
    const storeToVuex = {
      type: 'dataPic',
      dataPic: this.dataPic
    }

    if (this.currentTab === 'pic') {
      this.$store.commit('client/setPayloadAddPicBranch', storeToVuex)
    }
    this.selectedPIC(this.detailPICBranch)
  },
  watch: {
    dataPic: {
      handler (newValue) {
        const storeToVuex = {
          type: 'dataPic',
          dataPic: newValue
        }

        if (this.currentTab === 'pic') {
          this.$store.commit('client/setPayloadAddPicBranch', storeToVuex)
        }
      },
      deep: true
    },
    payloadAddPicBranch: {
      handler (newValue) {
        if (Object.keys(newValue.clientSelected).length > 0) {
          this.disabledInput = false
        } else {
          this.disabledInput = true
        }

        this.dataPic = newValue.dataPic
      },
      deep: true
    },
    clearDataPayloadPicBranch: function (newValue) {
      if (newValue === true) {
        this.dataPic = [
          {
            name: '',
            email: '',
            phone: ''
          }
        ]
        this.disabledInput = true
      }
    },
    detailPICBranch: {
      handler (newValue) {
        this.selectedPIC(newValue)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.wrap {
  padding: 40px;
  background: #f8f7fa;
  border-radius: 20px;
  border: 2px solid #f0f0f0;
}

.wrap-form {
  background: white;
  border: 1px solid #e1e1e1;
  padding: 40px;
  border-radius: 20px;
  border-bottom: 2px solid #e1e1e1;
}

.input {
  border-radius: 10px;
  border: 1px solid #e1e1e1;
  padding: 22px 12px;
}
</style>
